export const fmtDateFr = (iso) => {
  if (!iso) return "";
  const d = new Date(String(iso).slice(0, 10));
  return isNaN(d) ? iso : d.toLocaleDateString("fr-FR");
};

export const dirigeantLinkedin = (fullName, ville, linkedinDirigeant, isPrimary) => {
  if (isPrimary && linkedinDirigeant)
    return linkedinDirigeant.startsWith("http") ? linkedinDirigeant : `https://${linkedinDirigeant}`;
  return `https://www.linkedin.com/search/results/people/?keywords=${encodeURIComponent(`${fullName} ${ville || ""}`.trim())}`;
};

export function Field({ label, value, mono }) {
  return (
    <div className="py-2 border-b border-border">
      <div className="overline text-muted-foreground">{label}</div>
      <div className={`text-sm ${mono ? "font-mono" : ""}`}>{value || "—"}</div>
    </div>
  );
}
